"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = _interopRequireDefault(require("lodash"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactHtmlParser = _interopRequireDefault(require("react-html-parser"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var MANAGED_PROPS = ['guidance'];
var withGuidance = function withGuidance(WrappedComponent) {
  return function (props) {
    var filteredProps = _lodash.default.omit(props, MANAGED_PROPS);
    var guidance = props.guidance;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, guidance && /*#__PURE__*/_react.default.createElement("div", {
      className: "questionText"
    }, (0, _reactHtmlParser.default)(guidance)), /*#__PURE__*/_react.default.createElement(WrappedComponent, filteredProps));
  };
};
withGuidance.propTypes = {
  guidance: _propTypes.default.string
};
var _default = withGuidance;
exports.default = _default;